import { render, staticRenderFns } from "./blok-image.vue?vue&type=template&id=3c71ffec&scoped=true"
import script from "./blok-image.vue?vue&type=script&lang=js"
export * from "./blok-image.vue?vue&type=script&lang=js"
import style0 from "./blok-image.vue?vue&type=style&index=0&id=3c71ffec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c71ffec",
  null
  
)

export default component.exports